import * as React from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import { rgba } from "polished";
import { useInView } from "react-intersection-observer";
import ReactPlayer from "react-player";
import { useResizeDetector } from "react-resize-detector";
import { GatsbyImage } from "gatsby-plugin-image";

export const fragment = graphql`
  fragment HeroContent on ContentfulPageSectionHero {
    slogan
    videoUrl
    placeholderImage {
      gatsbyImageData(layout: FULL_WIDTH, width: 1920, height: 1080)
    }
    internal {
      type
    }
  }
`;

const Container = styled.div`
  height: 80vh;
  background: ${(props) => props.theme.colors.darkBlue};
  position: relative;
  overflow: hidden;
`;

const VideoContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200vw;
  height: 200vh;
  transform: translate(-50%, -50%);
`;

const PlaceholderImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const PlaceholderImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
`;

const VideoGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 95%,
      ${(props) => rgba(props.theme.colors.darkBlue, 1)} 100%
    ),
    linear-gradient(
      0deg,
      ${(props) => rgba(props.theme.colors.darkBlue, 0.2)},
      ${(props) => rgba(props.theme.colors.darkBlue, 0.2)}
    );
`;

const Hero = ({ data, setAtTop }) => {
  const { width, height, ref } = useResizeDetector();

  const inView = useInView({
    onChange: (inView) => {
      setAtTop(inView);
    },
    rootMargin: "-30% 0% -30% 0%",
  });

  let lengthMultiplier = null;
  if (width && height) {
    lengthMultiplier = Math.max(width / 1920, height / 1080);
  }

  return (
    <Container as={"section"} ref={ref}>
      {data.placeholderImage && (
        <PlaceholderImageContainer>
          <PlaceholderImage
            alt={""}
            image={data.placeholderImage.gatsbyImageData}
            objectFit={"cover"}
          />
        </PlaceholderImageContainer>
      )}
      <VideoContainer
        style={{
          width: lengthMultiplier && Math.ceil(lengthMultiplier * 1920),
          height: lengthMultiplier && Math.ceil(lengthMultiplier * 1080),
        }}
        ref={inView.ref}
      >
        <ReactPlayer
          url={data.videoUrl}
          playing
          loop
          muted
          playsinline
          width={"100%"}
          height={"100%"}
        />
      </VideoContainer>
       <VideoGradient /> 
    </Container>
  );
};

export const heroName = "ContentfulPageSectionHero";

export default Hero;
